module.exports = {
      id: "ic-wallstreet-30-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-wallstreet-30-usage",
      toString: function () {
        return this.url;
      }
    }